/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  googleAnalyticsId: null,
  googleGTMId: null,
  modulo: "",
  cantPasos: 2,
  pasos: {
    paso1: {
      path: "/",
      component: "views/Paso1",
      paso: 1,
      pasoSiguiente: "paso2",
      titulo: "Completá el formulario",
      subtitulo: "Ingresá tus datos, luego solicitá el cambio de banco.",
      subtitulo2:
        "Comenzá a acreditar tu jubilación ANSES en BBVA y te regalamos otra de $160.000"
    },
    gracias: {
      path: "/gracias",
      component: "views/Gracias"
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "views/Mensaje"
    }
  }
};
